var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpAttPrecisionGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#14BF96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.75C13.0586 14.75 11.5 13.1914 11.5 11.25C11.5 9.33594 13.0586 7.75 15 7.75C16.9141 7.75 18.5 9.33594 18.5 11.25C18.5 13.1914 16.9141 14.75 15 14.75ZM17.4609 16.1992C19.5664 16.6914 21.125 18.5781 21.125 20.8203C21.125 21.3398 20.6875 21.75 20.168 21.75H9.80469C9.28516 21.75 8.875 21.3398 8.875 20.8203C8.875 18.5781 10.4062 16.6914 12.5117 16.1992L13.6875 20.875L14.5625 17.1562L13.6875 15.625H16.3125L15.4375 17.1562L16.2852 20.875L17.4609 16.1992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpAttPrecisionGreen);
export default __webpack_public_path__ + "static/media/DlpAttPrecisionGreen.6d9dac770e25a5aaee7f9ebb89c1f295.svg";
export { ForwardRef as ReactComponent };